module.exports = __webpack_public_path__ + "static/img/box_img.7ef77a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/box_img.png
// module id = 3HiE
// module chunks = 128